import { isDefined } from "@clipboard-health/util-ts";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import {
  type ChartingNoncomplianceState,
  type GetChartingNoncompliancesResponse,
  GetChartingNoncompliancesResponseSchema,
} from "@src/appV2/redesign/Charting/api/schema";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";

interface GetChartingNoncompliancesParams {
  workerId: string;
  chartingVerified?: boolean;
  inReview?: boolean;
  state?: ChartingNoncomplianceState[];
}

export function useGetChartingNoncompliances(
  params: GetChartingNoncompliancesParams,
  options: UseQueryOptions<GetChartingNoncompliancesResponse> = {}
): UseQueryResult<GetChartingNoncompliancesResponse> {
  const { workerId, chartingVerified, inReview, state } = params;

  return useQuery<GetChartingNoncompliancesResponse>({
    queryKey: ["chartingNoncompliance", workerId],
    queryFn: async () => {
      const { data } = await get({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/charting-noncompliances`,
        responseSchema: GetChartingNoncompliancesResponseSchema,
        parseSchema: true,
        ...((isDefined(chartingVerified) || isDefined(inReview) || isDefined(state)) && {
          queryParams: {
            filter: {
              ...(isDefined(chartingVerified) && { chartingVerified }),
              ...(isDefined(inReview) && { inReview }),
              ...(isDefined(state) && { state: state.join(",") }),
            },
          },
        }),
      });

      return data;
    },
    ...options,
  });
}
